import script from "./FatigueRiskAssessmentCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./FatigueRiskAssessmentCompleted.vue?vue&type=script&setup=true&lang=js"

import "./FatigueRiskAssessmentCompleted.vue?vue&type=style&index=0&id=303eba2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-303eba2e"]])

export default __exports__